"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataObjectMaterialWrappingModeToThree = exports.dataObjectMaterialWrappingModeFromThree = void 0;
var realmforge_common_1 = require("realmforge-common");
var realms_three_1 = __importDefault(require("realms-three"));
/*
 * Converts a three data wrapping mode to data object material wrapping mode
 */
var dataObjectMaterialWrappingModeFromThree = function (mode) {
    switch (mode) {
        case realms_three_1.default.RepeatWrapping: {
            return realmforge_common_1.DataObjectMaterialWrappingMode.RepeatWrapping;
        }
        case realms_three_1.default.ClampToEdgeWrapping: {
            return realmforge_common_1.DataObjectMaterialWrappingMode.ClampToEdgeWrapping;
        }
        case realms_three_1.default.MirroredRepeatWrapping: {
            return realmforge_common_1.DataObjectMaterialWrappingMode.MirroredRepeatWrapping;
        }
    }
};
exports.dataObjectMaterialWrappingModeFromThree = dataObjectMaterialWrappingModeFromThree;
/*
 * Converts to three mapping mode
 */
var dataObjectMaterialWrappingModeToThree = function (mode) {
    switch (mode) {
        case realmforge_common_1.DataObjectMaterialWrappingMode.RepeatWrapping: {
            return realms_three_1.default.RepeatWrapping;
        }
        case realmforge_common_1.DataObjectMaterialWrappingMode.ClampToEdgeWrapping: {
            return realms_three_1.default.ClampToEdgeWrapping;
        }
        case realmforge_common_1.DataObjectMaterialWrappingMode.MirroredRepeatWrapping: {
            return realms_three_1.default.MirroredRepeatWrapping;
        }
    }
};
exports.dataObjectMaterialWrappingModeToThree = dataObjectMaterialWrappingModeToThree;
